import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { GetBO } from '../pages.modal';

@Injectable({
  providedIn: 'root'
})

export class ActiveSessionService extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }

  revokeSessions(revokeIds): Observable<number> {
    let url = "api/Auth/revokeSessions";
    return this.http.post<number>(url, revokeIds, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  public execute(openSessionstate: GetBO): void {
    this.getOpenSessions(openSessionstate).subscribe(x => super.next(x));
  }
  getOpenSessions(openSessionstate?: GetBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Auth/getOpenSessions?", openSessionstate)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }
}